<template>
  <a-modal icon="danger" iconColor="warning" class="network" :title="$t('alert.titlePoorNetwork')" @close="hide">
  <p class="text-- fw--bold">{{ $t('alert.subTitlePoorNetwork1') }}</p>
  <p class="text--">{{ $t('alert.subTitlePoorNetwork2') }}</p>
    <template #footer>
      <a-button variant="outline-primary"  @click="joinSession">{{ $t('dialog.button.process') }} </a-button>
      <a-button @click="hide"> {{ $t('dialog.button.cancel') }} </a-button>
    </template>
  </a-modal>
</template>

<script setup>
import {useAppStore} from '@/stores'
import {messenger} from '@communication'

const app = useAppStore()

const joinSession = () => {
  app.transition('HIDE_SLOW_NETWORK_MODAL')
  messenger.emit('session:join')
}

const hide = () => {
  app.transition('HIDE_SLOW_NETWORK_MODAL')
}
</script>

<style lang="scss">
.network {
  background-color: $backdrop;
  z-index: $zindex-modal;
}
ul {
  padding: 0 30px;
  margin-bottom: 0;
}
</style>
